import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    height: '150',
    overflow: 'visible',
  },
  disableSpacing: {
    paddingLeft: '0',
    paddingRight: '0',
  },
  coachAvatar: {
    border: '2px solid #DBD2C1',
    boxShadow:
      '0 0 0 1px #F7F7F7, 0 0 0 8px #FFFFFF, 0px 4px 36px rgba(0, 10, 22, 0.13)',
  },
  coachInfo: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    minHeight: '10rem',
  },
  actionBar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  coachTitle: {
    color: theme.palette.secondary.dark,
    fontWeight: 700,
    fontSize: '1rem',
  },
}))
